import type { Level } from "@-/dev.improve.haniverse.lib.level";

/**
 * The learner's current level: the first level with a character they have not studied, or `null`
 * once every level is done. The same rule as the Browse Levels list (which also skips levels a
 * free account cannot open).
 */
export function findCurrentLevelIndex(
  levels: readonly Level[],
  studiedGraphemes: ReadonlySet<string>,
): number | null {
  const currentLevel = levels.find(
    (level) => !level.characters.every((character) => studiedGraphemes.has(character)),
  );
  return currentLevel?.index ?? null;
}
